import instObj from '@/backend/axios-instances'

const resource = "mitrex/estimations/insulation"
const instance = instObj.baseInstance

export default {
  get(estimationId, parameters) {
    return instance.get(`${resource}/${estimationId}`, { params: parameters });
  },
  put(estimationId, data, parameters) {
    return instance.put(`${resource}/${estimationId}`, data, { params: parameters });
  },
  delete(estimationId) {
    return instance.delete(`${resource}/${estimationId}`);
  }
}
